<div class="container">
    <div>
        Pause Blind Level:
        <ion-select placeholder="Select Blind Level" [(ngModel)]="blind">
            <ion-select-option *ngFor="let blind of blinds; let i=index" [disabled]="disabledToIndex >= i" [value]="blind">{{blind}}</ion-select-option>
        </ion-select>
    </div>
    <div>
        Resume Date:
        <ion-datetime-button datetime="datetime-multi-day"></ion-datetime-button>
        <ion-popover [keepContentsMounted]="true">
            <ng-template>
                <ion-datetime
                    [showDefaultButtons]="true"
                    color="date-picker"
                    id="datetime-multi-day"
                    [(ngModel)]="resumeDate"
                    [min]="minTimeIsoString"
                    [max]="maxTimeIsoString"
                ></ion-datetime>
            </ng-template>
        </ion-popover>
    </div>
    <div class="buttons">
        <span
            class="cancel clickable ion-activatable"
            (click)="cancel()"
        >
            {{cancelText.toLowerCase()}}
            <ion-ripple-effect></ion-ripple-effect>
        </span>
        <span
            class="submit clickable ion-activatable"
            (click)="confirm()"
            [ngClass]="{disabled: !resumeDate || !blind}"
        >
            {{okText.toLowerCase()}}
            <ion-ripple-effect></ion-ripple-effect>
        </span>
    </div>
</div>